import { CheckCircle2, AlertTriangle } from 'lucide-react';

interface AddressVerificationBadgeProps {
  address: string | null | undefined;
  lat: number | null | undefined;
  lng: number | null | undefined;
}

/**
 * Shows a non-blocking indicator under an address input:
 * - Green when lat/lng are present (address was verified via autocomplete or prior geocode)
 * - Orange warning when address is typed but lat/lng are missing — save still works,
 *   the backend will auto-geocode as a safety net
 * - Nothing when no address is entered yet
 */
export function AddressVerificationBadge({ address, lat, lng }: AddressVerificationBadgeProps) {
  const hasAddress = !!address && address.trim().length > 0;
  if (!hasAddress) return null;

  const hasCoords = lat != null && lng != null;

  if (hasCoords) {
    return (
      <p className="mt-1 flex items-center gap-1 text-xs text-success">
        <CheckCircle2 className="h-3.5 w-3.5" />
        Address verified
      </p>
    );
  }

  return (
    <p className="mt-1 flex items-center gap-1 text-xs text-warning">
      <AlertTriangle className="h-3.5 w-3.5" />
      Address not verified. System will attempt to auto-locate.
    </p>
  );
}
